import { isObject } from 'paliari-js-utils'
import translate from '@/filters/translate'
import transliterate from '@/lib/transliterate'

function aclLabel(key) {
  if (!key) return ''
  let label = translate(`acl.${key}`)
  if (label) return label
  label = key.charAt(0).toUpperCase() + key.slice(1)

  return label.replace('_', ' ')
}

class Permissao {
  constructor(tree, checked = {}, key = '', parent = { checked: false }) {
    this.parent = () => parent
    this.checked = true === checked
    this.key = key
    this.label = aclLabel(key)
    this.open = false
    if (isObject(tree)) {
      this.permissoes = {}
      for (let k in tree) {
        this.permissoes[k] = new Permissao(tree[k], checked[k], k, this)
      }
    }
  }

  get name() {
    if (this.parent().key) {
      return `${this.parent().name}_${this.key}`
    }
    return this.key
  }

  get info() {
    return translate(`acl_info.${this.name}`)
  }

  get disabled() {
    return this.parent().checked
  }

  get checked() {
    return this.parent().checked || this._checked
  }

  set checked(v) {
    this._checked = v
  }

  get json() {
    if (this.checked) {
      return true
    }
    let ret = {}
    if (this.permissoes) {
      for (let k in this.permissoes) {
        let obj = this.permissoes[k].json
        if (true === obj || Object.keys(obj).length > 0) {
          ret[k] = obj
        }
      }
    }

    return ret
  }

  show(str) {
    if (
      !str ||
      new RegExp(
        transliterate(str)
          .split(' ')
          .join('.*'),
        'g',
      ).test(transliterate(this.label))
    ) {
      return true
    }
    if (this.permissoes) {
      for (let k in this.permissoes) {
        if (this.permissoes[k].show(str)) {
          return true
        }
      }
    }

    return false
  }

  toggleAll(value) {
    this.open = value
    if (this.permissoes) {
      for (let k in this.permissoes) {
        this.permissoes[k].toggleAll(value)
      }
    }
  }

  collapseAll() {
    this.toggleAll(true)
  }

  expandAll() {
    this.toggleAll(false)
  }
}

export default Permissao
